import * as Sentry from '@sentry/browser';

import { ErrorHandler, Injectable } from '@angular/core';

import { environment } from '@nrwl/environment';

@Injectable({
  providedIn: 'root',
})
export class SentryHandlerService implements ErrorHandler {
  public init() {
    Sentry.init({
      ignoreErrors: ['Non-Error exception captured'],
      dsn: environment.sentryDSN,
    });
  }

  public handleError(error) {
    const eventId = Sentry.captureException(error.originalError || error);
    console.error(error);
    //Sentry.showReportDialog({ eventId });
  }
}
